import type { CreateLocalGiftCardRequest } from "common/models/api/models/CreateLocalGiftCardRequest";
import { useToast } from "@commonlibs";
import { useMutation, UseMutationResult, useQueryClient } from "react-query";
import useTranslate from "ui/locale/hooks/useTranslate";
import { Queries } from "ui/query/queries";
import type { UseCustomMutationOptions } from "ui/query/react-query-overrides";
import { giftcardsApi } from "../api/giftcardsApi";

export default function useCreateLocalGiftcard({
    onSuccess,
    ...options
}: UseCustomMutationOptions<void, unknown, CreateLocalGiftCardRequest>): UseMutationResult<void, unknown, CreateLocalGiftCardRequest> {
    const translate = useTranslate();
    const { showToast } = useToast();
    const queryClient = useQueryClient();

    const handleOnSuccess = (data: void, variables: CreateLocalGiftCardRequest, context: unknown) => {
        showToast(translate("giftCardCreatedSuccessfully"), { type: "success" });
        queryClient.invalidateQueries(Queries.GIFTCARDS_FIND_ALL);
        onSuccess?.(data, variables, context);
    };

    return useMutation(
        async (body: CreateLocalGiftCardRequest) => {
            await giftcardsApi.createLocalGiftcard(body);
        },
        {
            onSuccess: handleOnSuccess,
            ...options,
        },
    );
}
